<main class="homepage">
        <div class="head flexContent16 flex-column">
            <div>
              <h1 class="font-s48 mb-0">{{ 'structure.structureHead' | translate}}</h1>
            </div>
            <div class="btns" *ngIf="this.user.IsWorker">
                  <div class="btn w-180px trader" [ngClass]="{'activeBtn': isTraderActive}" (click)="isTraderActive = true; isWorkerActive = false">{{ 'structure.forTrader' | translate}}</div>
                  <div class="btn w-180px worker" [ngClass]="{'activeBtn': isWorkerActive}" (click)="isWorkerActive = true; isTraderActive = false">{{ 'structure.forWorker' | translate}}</div>
            </div>
        </div>

        <div class="main_component">
            <div class="image-background">
                <div class="cards-wrapper m-auto">

                    <div class="flexContentColumn32">
                        <div class="card h-390">
                            <ul class="tree">
                                <ul>
                                  <li class="font-s20">{{ 'general.homePage' | translate}}</li>
                                  <li>{{ 'general.auctions' | translate}}</li>
                                  <li>{{ 'general.news' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.demandCatalog' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.offersCatalog' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.goodsCatalog' | translate}}</li>
                                  <li>{{ 'structure.documents' | translate}}</li>
                                  <li>{{ 'general.FAQ' | translate}}</li>
                                </ul>
                            </ul>
                          </div>

                          <div class="card h-390">
                            <ul class="tree">
                                <ul>
                                  <li class="font-s20">{{ 'header.top_line.menu.admission' | translate}}</li>
                                  <li *ngIf="!user?.IsWorker || isTraderActive">{{ 'structure.violationsBT' | translate}}</li>
                                  <li *ngIf="!user?.IsWorker || isTraderActive">{{ 'structure.violationsTraders' | translate}}</li>
                                  <li *ngIf="!user?.IsWorker || isTraderActive">{{ 'structure.violationsClients' | translate}}</li>
                                  <li *ngIf="!user?.IsWorker || isTraderActive">{{ 'structure.violationsBrokers' | translate}}</li>

                                  <li *ngIf="isWorkerActive">{{ 'structure.fines' | translate}}</li>
                                  <li *ngIf="isWorkerActive">{{ 'structure.processingMNS' | translate}}</li>
                                  <li *ngIf="isWorkerActive">{{ 'structure.processingKGB' | translate}}</li>
                                  <li *ngIf="isWorkerActive">{{ 'structure.register' | translate}}</li>
                                </ul>
                            </ul>
                          </div>
                    </div>


                    <div class="flexContentColumn32">
                        <div class="card h-390">
                            <ul class="tree">
                                <ul>
                                 <li class="font-s20">{{ 'header.top_line.menu.catalog' | translate}}</li>
                                 <li class="mainActiveColor" (click)="goToCatalog(IdDirection.buy)">{{ 'header.top_line.menu.demandCatalog' | translate}}</li>
                                 <li class="mainActiveColor" (click)="goToCatalog(IdDirection.sale)">{{ 'header.top_line.menu.offersCatalog' | translate}}</li>
                                 <li>{{ 'header.top_line.menu.goodsCatalog' | translate}}</li>
                                </ul>
                            </ul>
                          </div>

                          <div class="card h-390" *ngIf="!user?.IsWorker || isTraderActive">
                            <ul class="tree">
                                <ul>
                                  <li class="font-s20">{{ 'structure.offers' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.offers' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" class="sub" (click)="goToOffersMan(IdSection.metalProducts)">{{ 'footer.top_line.fouth.link_1' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" class="sub" (click)="goToOffersMan(IdSection.forestProducts)">{{ 'footer.top_line.fouth.link_2' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" class="sub" (click)="goToOffersMan(IdSection.agricultural)">{{ 'footer.top_line.fouth.link_3' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" class="sub" (click)="goToOffersMan(IdSection.promising)">{{ 'footer.top_line.fouth.link_4' | translate}}</li>
                                </ul>
                            </ul>
                          </div>

                          <div class="card h-390" *ngIf="isWorkerActive">
                            <ul class="tree">
                                <ul>
                                 <li class="font-s20">{{ 'header.top_line.menu.auctions' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.auctions' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.offers' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.registrations' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.traders' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.deposit' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.deals' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.messages' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.setting' | translate}}</li>
                                </ul>
                            </ul>
                          </div>

                    </div>

                    <div class="flexContentColumn32" *ngIf="!user?.IsWorker || isTraderActive">
                        <div class="card h-175">
                            <ul class="tree">
                                <ul>
                                 <li class="font-s20">{{ 'header.top_line.menu.sessionsSchedule' | translate}}</li>
                                </ul>
                            </ul>
                        </div>

                        <div class="card h-175">
                            <ul class="tree">
                                <ul>
                                 <li class="font-s20">{{ 'structure.notifications' | translate}}</li>
                                  <li>{{ 'structure.personNotifications' | translate}}</li>
                                  <li>{{ 'structure.announcements' | translate}}</li>
                                </ul>
                            </ul>
                        </div>

                        <div class="card h-390">
                            <ul class="tree">
                                <ul>
                                 <li class="font-s20">{{ 'header.top_line.menu.auctions' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.auctions' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.myOffers' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.myRegistrations' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.deposit' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.deals' | translate}}</li>
                                  <li *ngIf="user?.IsWorker || isTraderActive" (click)="goToLink(strAuctions)">{{ 'structure.messages' | translate}}</li>
                                </ul>
                            </ul>
                        </div>
                      </div>

                      <div class="flexContentColumn32" *ngIf="isWorkerActive">
                        <div class="card h-390">
                            <ul class="tree">
                                <ul>
                                 <li class="font-s20">{{ 'header.top_line.menu.sessions' | translate}}</li>
                                  <li (click)="goToLink(strSessionShedule)">{{ 'header.top_line.menu.sessionsSchedule' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.sessionManNts' | translate}}</li>
                                  <li class="sub" (click)="goToLink(strSessions)">{{ 'header.top_line.menu.sessions' | translate}}</li>
                                  <li class="sub" (click)="goToLink(strSessionsTemplate)">{{ 'header.top_line.menu.sessionsTempl' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.sessionManOld' | translate}}</li>
                                </ul>
                            </ul>
                        </div>
                        <div class="card h-390">
                            <ul class="tree">
                                <ul>
                                 <li class="font-s20">{{ 'header.top_line.menu.personalSection' | translate}}</li>
                                  <li>{{ 'structure.calendar' | translate}}</li>
                                  <li>{{ 'structure.financialDocuments' | translate}}</li>
                                  <li>{{ 'structure.announcementsBoard' | translate}}</li>
                                  <li>{{ 'structure.IAPManagement' | translate}}</li>
                                  <li>{{ 'structure.exchangeRates' | translate}}</li>
                                  <li>{{ 'structure.exchangeFee' | translate}}</li>
                                  <li>{{ 'structure.arbitration' | translate}}</li>
                                  <li>{{ 'structure.reports' | translate}}</li>
                                  <li>{{ 'structure.setting' | translate}}</li>
                                </ul>
                            </ul>
                        </div>
                      </div>

                      <div class="flexContentColumn32">
                        <div class="card h-815">
                            <ul class="tree" *ngIf="!user?.IsWorker || isTraderActive">
                                <ul>
                                  <li class="font-s20">{{ 'header.top_line.menu.personalSection' | translate}}</li>
                                  <li>{{ 'structure.accreditation' | translate}}</li>
                                  <li>{{ 'structure.brokerClients' | translate}}</li>
                                  <li>{{ 'structure.infoSubscriptions' | translate}}</li>
                                  <li>{{ 'structure.finance' | translate}}</li>
                                  <li>{{ 'structure.controlOfExecution' | translate}}</li>
                                  <li>{{ 'structure.progressOfTrading' | translate}}</li>
                                  <li>{{ 'structure.arbitration' | translate}}</li>
                                  <li>{{ 'structure.acceptedOffers' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.goodsCatalog' | translate}}</li>
                                  <li>{{ 'structure.registries' | translate}}</li>
                                  <li>{{ 'structure.contracts' | translate}}</li>
                                  <li>{{ 'structure.agreements' | translate}}</li>
                                  <li>{{ 'structure.reports' | translate}}</li>
                                </ul>
                            </ul>


                            <ul class="tree" *ngIf="isWorkerActive">
                                <ul>
                                 <li class="font-s20">{{ 'structure.offers' | translate}}</li>
                                  <li>{{ 'header.top_line.menu.offers' | translate}}</li>
                                  <li class="sub" (click)="goToOffersMan(1)">{{ 'footer.top_line.fouth.link_1' | translate}}</li>
                                  <li class="sub" (click)="goToOffersMan(2)">{{ 'footer.top_line.fouth.link_2' | translate}}</li>
                                  <li class="sub" (click)="goToOffersMan(3)">{{ 'footer.top_line.fouth.link_3' | translate}}</li>
                                  <li class="sub" (click)="goToOffersMan(7)">{{ 'footer.top_line.fouth.link_4' | translate}}</li>
                                  <li (click)="goToLink(strModels)">{{ 'header.top_line.menu.modelBuilder' | translate}}</li>
                                  <li (click)="goToLink(strRules)">{{ 'header.top_line.menu.rulesBuilder' | translate}}</li>
                                  <li>{{ 'structure.archive' | translate}}</li>
                                  <li class="sub">{{ 'structure.unrealizedVolumes' | translate}}</li>
                                  <li class="sub">{{ 'structure.progressSession' | translate}}</li>
                                </ul>
                            </ul>
                        </div>
                      </div>
                </div>
            </div>
    </div>
</main>
